import React from "react";

const LoadingSign = () => {
  return (
    <div>
      <p className="ml-4 font-bold">Loading... </p>
    </div>
  );
};

export default LoadingSign;
